import { PermissionsBasedRoute } from '~/app/PermissionsBasedRoute'
import { PrivateElement } from '~/app/PrivateElement'

import { LocationsPage } from './LocationsPage'

export const LocationRoutes = () => {
  return (
    <PrivateElement>
      <PermissionsBasedRoute>
        <LocationsPage />
      </PermissionsBasedRoute>
    </PrivateElement>
  )
}
